import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { GlobalComponent } from 'src/app/global-component';
import { BaseSearchModel } from '../../models/query/base-search.model';
import { FilterModel } from '../../models/security/filters.model';

export type SortDirection = 'asc' | 'desc' | '';

@Injectable({
  providedIn: 'root'
})

export abstract class BaseListService implements OnDestroy {

  private clientSideOnlyList: boolean = false;

  protected FilterModelArray: FilterModel[]|undefined = undefined;

  defaultListState: BaseSearchModel = {
    sortColumnDirective: "createdDate",
    sortDirectionDirective: 'desc',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    sortColumn: "createdDate",
    sortDirection: "desc",
    searchTerm: undefined,
  };

  protected unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  protected _loading$ = new BehaviorSubject<boolean>(true);
  protected _search$ = new Subject<void>();
  protected _total$ = new BehaviorSubject<number>(0);

  protected _state: any = { ...this.defaultListState };

  get total$() { return this._total$.asObservable(); }
  get loading$() { return this._loading$.asObservable(); }
  get pageIndex() { return this._state.pageIndex; }
  get pageSize() { return this._state.pageSize; }
  get searchTerm() {
    if (this._state.searchTerm == undefined) {
      this._state.searchTerm = ``;
    }
    return this._state.searchTerm
  }
  get startIndex() { if (this._total$.value === 0) { return 0 } return this._state.startIndex;  }
  get totalRecords() { return this._total$.value; }
  get searchModel() { return this._state; }

  set setClientSideOnlyList(clientSideOnlyList: boolean) { this.clientSideOnlyList = clientSideOnlyList; }

  set pageIndex(pageIndex: number) { this._set({ pageIndex }); }
  set startIndex(startIndex: number) { this._set({ startIndex }); }
  set startIndexNoSearch(startIndex: number) { this._state.startIndex = startIndex; }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set pageSizeNoSearch(pageSize: number) { this._setNoSearch({ pageSize }); }
  set searchTerm(searchTerm: string) { this._set({ searchTerm }); }
  set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
  set sortColumnDirective(sortColumnDirective: string) { this._setNoSearch({ sortColumnDirective }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

  protected _set(patch: Partial<any>) {
    Object.assign(this._state, patch);
    if(this.clientSideOnlyList === false){
      this._search$.next();
    }
  }

  protected _setNoSearch(patch: Partial<any>) {
    Object.assign(this._state, patch);
  }

  public refresh() {
    this._search$.next();
  }

  public resetListState(confirmation: boolean| undefined){
    if(confirmation === true){
      this.clearListService();
    }
  }


  protected titleCaseWord(str: string | undefined) {
    if (str != null && str.length >= 2) {
      str = str[0].toUpperCase() + str.slice(1);
    }
    return str;
  }

  validateStartIndex() {
    if (this._state.startIndex < 0) {
      this._state.startIndex = 0;
    }

    if (this._state.startIndex >= 1) {
      this._state.pageIndex = this._state.startIndex - 1;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  abstract clearListService(): void;
  protected abstract _search(): any;

}
